import React from 'react';
import { getBrandLogo } from './utils/brandLogo';

/**
 * Single centered glass pill with the dealer logo, anchored at the top of
 * the hero photo. Used by the used-VIN landing (LandingBody).
 *
 * New-model (Autodis OMODA/JAECOO) landing renders its branding via
 * SalonHeader (Autodis logo) + GlassInfoCard (manufacturer logo in the
 * info card), NOT this pill (#1022). Returns null if no logo source
 * (protects widget-mode without explicit branding.logoUrl, #897).
 *
 * @param {object} props
 * @param {object} props.car — Car object (DealerCarDto).
 */
const BrandLogoPill = ({ car }) => {
  const { src: brandSrc, alt: brandAlt } = getBrandLogo(car);
  if (!brandSrc) return null;

  return (
    <div className="landing__logo-pill">
      <img className="landing__logo-img" src={brandSrc} alt={brandAlt} />
    </div>
  );
};

export default React.memo(BrandLogoPill);
